import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {EmrCasePaperComponent} from './emr-case-paper.component';

const routes: Routes = [
  {
    path: 'emrsidebar/emr-case-paper/:source/:visit_id', component: EmrCasePaperComponent
  }
];
export const routing: ModuleWithProviders = RouterModule.forChild(routes);




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/emrsidebar/emr-case-paper/emr-case-paper.routing.ts